<template>
  <button class="button-menu-mobile open-left" @click="sidebarToggle">
    <i class="mdi mdi-menu"></i>
  </button>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'

import { useStore } from 'vuex'

import { event } from 'vue-gtag'

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
    required: false
  }
})

const store = useStore()
const clickable = ref(true)

const user = computed(() => store.state.retailerAuth.user)
const noSalesChannels = computed(() => user.value?.retailer?.sales_channels?.length === 0)
const sidebarActive = computed(() => store.state.sideMenu.sidebarActive)

const sidebarToggle = () => {
  if (sidebarActive.value) {
    closeMenu()
  } else {
    openMenu()
  }
  window.dispatchEvent(new Event('resize'))

  const eventActionValues = {
    event_action: sidebarActive.value ? 'menu_opened' : 'menu_hidden'
  }

  event('page_actions', eventActionValues)
}

const openMenu = () => {
  if (clickable.value === true) {
    clickable.value = false
    document.body.className = 'sidebar-enable'
    store.commit('sideMenu/SET_SIDEBAR_COLLAPSE_STATE', true)
    clickable.value = true
    document.body.setAttribute('data-leftbar-compact-mode', 'scrollable')
    localStorage.setItem('sidebarOpened', '1')
  }
}

const closeMenu = () => {
  if (clickable.value === true) {
    clickable.value = false
    document.body.className = 'enlarged'
    store.commit('sideMenu/SET_SIDEBAR_COLLAPSE_STATE', false)
    clickable.value = true
    document.body.setAttribute('data-leftbar-compact-mode', 'condensed')
    localStorage.setItem('sidebarOpened', '0')
  }
}

const documentClick = e => {
  if (mobileCheck()) {
    const element = document.querySelector('.button-menu-mobile')
    const el = document.querySelector('.left-side-menu')
    const target = e?.target || null
    if (
      element &&
      element !== target &&
      !element.contains(target) &&
      !el.contains(target) &&
      e.target.className !== 'left-side-menu' &&
      sidebarActive.value
    ) {
      closeMenu()
    }
  }
}

const mobileCheck = () => {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true
  }

  return false
}

onMounted(() => {
  document.body.className = mobileCheck() ? 'enlarged' : 'sidebar-enable'
  document.addEventListener('click', documentClick)

  if (mobileCheck() === false) {
    return openMenu()
  }
})

onUnmounted(() => {
  document.removeEventListener('click', documentClick)
})

watch(
  () => props.isOpen,
  (newValue, oldValue) => {
    if (!oldValue && newValue) {
      openMenu()
    } else if (oldValue && !newValue) {
      closeMenu()
    }
  }
)
</script>

<style scoped></style>
